// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .PanelWrapper-pageContainer-F9CXM {
 	width: 100%;
 	max-width: 1080px;
 	margin-left: auto;
 	margin-right: auto;
 	overflow: hidden;
 }

 .PanelWrapper-containerResponsive-vLyD4 {
 	max-width: 1080px;
 	margin: 0 auto;
 }

 .PanelWrapper-space2-lDV6s {
 	margin-bottom: 12px;
 }

 .PanelWrapper-space3-oZMV7 {
 	margin-bottom: 18px;
 }

 .PanelWrapper-space4-djNw9 {
 	margin-bottom: 48px;
 }

 .PanelWrapper-spaceTop3-TMLm8 {
 	margin-top: 18px;
 }

 .PanelWrapper-spaceTop4-Ermhx {
 	margin-top: 24px;
 }

 .PanelWrapper-spaceTop2-zleE4 {
 	margin-top: 12px;
 }

 .PanelWrapper-sliderHeader-UerZI {
 	margin-top: 0;
 	font-size: 18px;
 	color: var(--common-text-color);
 }

 .PanelWrapper-lineCss-m37wh {
 	margin: 18px 0;
 	border: 1px solid var(--primary-border);
 }`, "",{"version":3,"sources":["webpack://./src/components/ViewProfile/ManageListing/PanelWrapper/PanelWrapper.css"],"names":[],"mappings":"CAAC;EACC,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;CACjB;;CAEA;EACC,iBAAiB;EACjB,cAAc;CACf;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,eAAe;EACf,+BAA+B;CAChC;;CAEA;EACC,cAAc;EACd,uCAAuC;CACxC","sourcesContent":[" .pageContainer {\n \twidth: 100%;\n \tmax-width: 1080px;\n \tmargin-left: auto;\n \tmargin-right: auto;\n \toverflow: hidden;\n }\n\n .containerResponsive {\n \tmax-width: 1080px;\n \tmargin: 0 auto;\n }\n\n .space2 {\n \tmargin-bottom: 12px;\n }\n\n .space3 {\n \tmargin-bottom: 18px;\n }\n\n .space4 {\n \tmargin-bottom: 48px;\n }\n\n .spaceTop3 {\n \tmargin-top: 18px;\n }\n\n .spaceTop4 {\n \tmargin-top: 24px;\n }\n\n .spaceTop2 {\n \tmargin-top: 12px;\n }\n\n .sliderHeader {\n \tmargin-top: 0;\n \tfont-size: 18px;\n \tcolor: var(--common-text-color);\n }\n\n .lineCss {\n \tmargin: 18px 0;\n \tborder: 1px solid var(--primary-border);\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `PanelWrapper-pageContainer-F9CXM`,
	"containerResponsive": `PanelWrapper-containerResponsive-vLyD4`,
	"space2": `PanelWrapper-space2-lDV6s`,
	"space3": `PanelWrapper-space3-oZMV7`,
	"space4": `PanelWrapper-space4-djNw9`,
	"spaceTop3": `PanelWrapper-spaceTop3-TMLm8`,
	"spaceTop4": `PanelWrapper-spaceTop4-Ermhx`,
	"spaceTop2": `PanelWrapper-spaceTop2-zleE4`,
	"sliderHeader": `PanelWrapper-sliderHeader-UerZI`,
	"lineCss": `PanelWrapper-lineCss-m37wh`
};
module.exports = ___CSS_LOADER_EXPORT___;
